import React from "/vendor/react";
import createSvgIcon from "./createSvgIcon";

const DashboardIconLight = createSvgIcon(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
      width="24"
      height="24"
    >
      <g fill="#000000" fillRule="evenodd">
        <path
          d="M12 21.4c5.2 0 9.5-4.3 9.5-9.4 0-5.2-4.3-9.5-9.5-9.5A9.5 9.5 0 0 0 2.5 12c0 5.1 4.3 9.4 9.5 9.4Zm0-1.6A7.8 7.8 0 0 1 4.2 12c0-4.4 3.5-7.8 7.8-7.8a7.8 7.8 0 1 1 0 15.6Z"
          opacity=".71"
          fill="#000000"
        />
        <path
          d="M12 17.6c.8 0 1.5-.7 1.5-1.5 0-.6-.4-1.1-.9-1.4v-4.2c0-.4-.3-.7-.6-.7s-.6.3-.6.7v4.2a1.5 1.5 0 0 0 .6 2.9Z"
          fill="#000000"
        />
        <path
          d="M12 5.8c3.2 0 5.4 1.5 6 4.3a2 2 0 0 0-1.5.1c-.5-2-2-3-4.5-3C9 7.3 7.2 9 7.2 12a.7.7 0 1 1-1.5 0c0-4 2.4-6.3 6.3-6.3Z"
          opacity=".3"
          fill="#000000"
        />
        <circle cx="17.5" cy="12" r="1" fill="#000000" />
      </g>
    </svg>,
    'DashboardIconLight'
  );

  const DashboardIconDark = createSvgIcon(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
      width="24"
      height="24"
    >
      <g fill="#E8E6E3" fillRule="evenodd">
        <path
          d="M12 21.4c5.2 0 9.5-4.3 9.5-9.4 0-5.2-4.3-9.5-9.5-9.5A9.5 9.5 0 0 0 2.5 12c0 5.1 4.3 9.4 9.5 9.4Zm0-1.6A7.8 7.8 0 0 1 4.2 12c0-4.4 3.5-7.8 7.8-7.8a7.8 7.8 0 1 1 0 15.6Z"
          opacity=".71"
          fill="#E8E6E3"
        />
        <path
          d="M12 17.6c.8 0 1.5-.7 1.5-1.5 0-.6-.4-1.1-.9-1.4v-4.2c0-.4-.3-.7-.6-.7s-.6.3-.6.7v4.2a1.5 1.5 0 0 0 .6 2.9Z"
          fill="#E8E6E3"
        />
        <path
          d="M12 5.8c3.2 0 5.4 1.5 6 4.3a2 2 0 0 0-1.5.1c-.5-2-2-3-4.5-3C9 7.3 7.2 9 7.2 12a.7.7 0 1 1-1.5 0c0-4 2.4-6.3 6.3-6.3Z"
          opacity=".3"
          fill="#E8E6E3"
        />
        <circle cx="17.5" cy="12" r="1" fill="#E8E6E3" />
      </g>
    </svg>,
    'DashboardIconDark'
  );

const DashboardIcon = ({ dark = false }) => {
    return dark ? DashboardIconDark : DashboardIconLight;
};

export default DashboardIcon;

